export async function getList({commit}) {
  const {data} = await this.$adminRepositories.mstFields.index();
  return commit('setList', data.data);
}

export async function saveAsMaster({commit}, {id, payload}) {
  const {errResponse, data: responseData} = await this.$adminRepositories.mstFields.saveAsMaster(id, payload);
  if(!errResponse) {
    await commit('admin/applications/addField', responseData.data, {root: true});
    return responseData.message;
  }

  return null;
}

export async function deleteMstFieldById({commit}, payload) {
  const {data} = await this.$adminRepositories.mstFields.delete(payload.id);
  await commit('removeItem', payload.index);
  return data;
}

export async function createMstField({commit}, payload) {
  commit('setBtnLoading', true, {root: true});
  const {data} = await this.$adminRepositories.mstFields.create(payload);
  commit('setBtnLoading', false, {root: true});
  return data;
}

export async function updateMstField({commit}, payload) {
  commit('setBtnLoading', true, {root: true});
  const {data} = await this.$adminRepositories.mstFields.update(payload.id, payload);
  commit('setBtnLoading', false, {root: true});
  return data
}

export async function findMstFieldById({}, payload) {
  const {data} = await this.$adminRepositories.mstFields.show(payload);
  return data;
}
